var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#4C7D9F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3661 10.2343C19.6785 10.5467 19.6785 11.0533 19.3661 11.3657L12.9661 17.7657C12.6537 18.0781 12.1471 18.0781 11.8347 17.7657L8.63471 14.5657C8.32229 14.2533 8.32229 13.7467 8.63471 13.4343C8.94712 13.1219 9.45366 13.1219 9.76608 13.4343L12.4004 16.0686L18.2347 10.2343C18.5471 9.9219 19.0537 9.9219 19.3661 10.2343Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/Circle.ab0fe27aed298041d06d344410992e33.svg";
export { ForwardRef as ReactComponent };